import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import 'bootstrap-icons/font/bootstrap-icons.css';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './appInsights';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AppInsightsContext.Provider value={reactPlugin}>
      <App />
    </AppInsightsContext.Provider>
  </React.StrictMode>,
)